/**
 * Procent wynagrodzenia za dni urlopu wg KP, orientacyjnie.
 * UWAGA: nie uwzględnia szczegółów (po 33 dniach L4 płaci ZUS, ciąża/wypadek = 100% L4 itd.).
 * Realne wyliczenia robi księgowa — to wyłącznie info dla pracownika i podpowiedź dla admina.
 *
 * ⚠ To jest liczba INFORMACYJNA (badge „80%” przy typie urlopu).
 * Silnik rozliczenia jej NIE mnoży — patrz `VACATION_HOURS_PERCENT` niżej.
 */
export const VACATION_PAYMENT_PERCENT = {
    WYPOCZYNKOWY: 100,
    NA_ZADANIE: 100,
    OPIEKA_NAD_DZIECKIEM: 100,
    CHOROBOWY: 80,
    BEZPLATNY: 0,
};
/**
 * Ile procent pełnego dnia pracy zalicza jeden dzień danej nieobecności.
 *
 * TO JEST JEDYNY MNOŻNIK W ROZLICZENIU. Model przyjęty świadomie:
 * obniżkę niesie liczba godzin, a stawka zostaje pełna, więc
 *
 *     wynagrodzenie za nieobecność = zaliczone godziny × pełna stawka
 *
 * Dla L4 daje to 8h × etat × 80% = 6,4 h przy pełnym etacie, a kwota wychodzi
 * identycznie jak przy starym „40 h × stawka × 80%”. Różnica jest w godzinach:
 * L4 przestaje udawać pełny dzień pracy w raporcie i w progresie pracownika.
 *
 * ⚠ NIGDY nie mnóż `VACATION_PAYMENT_PERCENT` × `VACATION_HOURS_PERCENT` —
 * dla L4 dałoby to 64% zamiast 80%. Procent płatności jest już „zaszyty”
 * w godzinach. Dlatego obie tablice mają dziś te same wartości i muszą
 * pozostać zgodne; rozjazd = błąd na liście płac.
 */
export const VACATION_HOURS_PERCENT = {
    WYPOCZYNKOWY: 100,
    NA_ZADANIE: 100,
    OPIEKA_NAD_DZIECKIEM: 100,
    CHOROBOWY: 80,
    BEZPLATNY: 0,
};
export const VACATION_PAYMENT_DISCLAIMER = 'Płatność orientacyjna wg KP. Realne wynagrodzenie nalicza księgowa.';
/**
 * Nazwa nieobecności w wierszu dziennej tabeli raportu — forma samodzielna,
 * z wielkiej litery (inaczej niż `VACATION_TYPE_LABEL` w PDF, gdzie typ stoi
 * po dwukropku).
 */
export const VACATION_TYPE_ROW_LABEL = {
    WYPOCZYNKOWY: 'Urlop wypoczynkowy',
    NA_ZADANIE: 'Urlop na żądanie',
    OPIEKA_NAD_DZIECKIEM: 'Opieka nad dzieckiem',
    CHOROBOWY: 'Chorobowe (L4)',
    BEZPLATNY: 'Urlop bezpłatny',
};
/**
 * Opis dnia nieobecności w kolumnie „Status": rodzaj + informacja o wymiarze,
 * gdy dzień nie liczy się w całości. Wspólne dla PDF i strony raportu, więc
 * księgowa widzi ten sam tekst niezależnie od tego, gdzie patrzy.
 */
export function absenceStatusLabel(entry) {
    const label = VACATION_TYPE_ROW_LABEL[entry.type];
    if (entry.percent === 0)
        return `${label} — nie wlicza się do godzin`;
    if (entry.percent !== 100)
        return `${label} — ${entry.percent}% dnia`;
    return label;
}
//# sourceMappingURL=vacation-payments.js.map